/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _6 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Введение</h2>
    <p className={styles.description}>
      Разберем базовые операции ввода/вывода, достаточные для получения и отображения данных от пользователя, до того
      как научимся работать с HTML-документом.
    </p>

    <section className={styles.subsection}>
      <h2 className={styles.h2}>2 - Вывод данных</h2>
      <p className={styles.description}>
        Для вывода данных будем использовать 2 метода: <code className={styles.code}>console.log()</code> и{' '}
        <code className={styles.code}>alert()</code>.
      </p>

      <p className={styles.notificationStudy}>
        <code className={styles.codeError}>console</code> и <code className={styles.codeError}>alert</code> являются
        частью интерфейса <code className={styles.codeError}>window</code> - глобального объекта, доступного при
        исполнении скрипта на веб-странице. Запись
        <code className={styles.codeError}>window.alert()</code> избыточна, пишем просто{' '}
        <code className={styles.codeError}>alert()</code> или <code className={styles.codeError}>console.log()</code>.
        Детальнее об этом будем говорить дальше в курсе.
      </p>
      <CopyBlock
        text={`const message = 'JavaScript is awesome!';
/*
 * В круглых скобках указываем имя переменной,
 * значение которой необходимо вывести в консоль
 */
console.log(message); // JavaScript is awesome!

const name = 'Mango';
/*
 * Можно сначала указать какую-то произвольную строку,
 * к примеру описывающую переменную или дополняющую ее, после чего
 * поставить запятую и указать имя переменной
 */
console.log('My name is: ', name); // My name is: Mango

/*
 * alert выводит модальное окно, текст которого соотсветствует значению
 * переменной (или литерала) которую мы укажем в скобках.
 */
alert(message);`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
      <a
        className={styles.link}
        rel="noopener noreferrer"
        href="https://medium.com/free-code-camp/how-to-use-the-javascript-console-going-beyond-console-log-5128af9d573b"
        target="_blank"
      >
        How to use the JavaScript console: going beyond console.log()
      </a>
    </section>

    <section className={styles.subsection}>
      <h2 className={styles.h2}>3 - Получение данных</h2>
      <p className={styles.description}>
        Для получения данных от пользователя будем использовать <code className={styles.code}>prompt()</code> и
        <code className={styles.code}>confirm()</code>, это тоже методы из интерфейса{' '}
        <code className={styles.code}>window</code>. Их особенность в том, что результатом своего выполнения они
        возвращают то, что было введено пользователем. Результат их работы можно записать в переменную для дальнейшего
        использования.
      </p>
      <p className={styles.description}>
        <code className={styles.code}>confirm()</code> — выводит модальное окно с сообщением, и 2 кнопки,{' '}
        <code className={styles.code}>Ok</code> и <code className={styles.code}>Cancel</code>. При нажатии на{' '}
        <code className={styles.code}>Ok</code>, на место вызова функции возвращается{' '}
        <code className={styles.code}>true</code>, при нажатии на
        <code className={styles.code}>Cancel</code> возвращается <code className={styles.code}>false</code>.
      </p>
      <CopyBlock
        text={`/*
 * Просим клиента подтвердить бронь на отель
 * и сохраняем в переменную результат работы confirm
 */
const isComing = confirm('Please confirm hotel reservation');
console.log(isComing);`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
      <p className={styles.description}>
        <code className={styles.code}>prompt()</code> — выводит модальное окно с полем ввода и кнопками{' '}
        <code className={styles.code}>Ok</code> и <code className={styles.code}>Cancel</code>. При{' '}
        <code className={styles.code}>Ok</code> возвращает то, что было введено в поле ввода, при{' '}
        <code className={styles.code}>Cancel</code> возвращает
        <code className={styles.code}>null</code>.
      </p>
      <CopyBlock
        text={`/*
 * Спрашиваем имя отеля в котором хотел бы остановится клиент
 * и сохраняем в переменную результат вызова prompt
 */
const hotelName = prompt('Please enter desired hotel name:');
console.log(hotelName);

/*
 * Важная особенность prompt в том, что не зависимо что ввел пользователь,
 * всегда вернется строка. Тоесть если пользователь ввел 5, то вернется
 * не число 5, а строка "5". Об этом необходимо всегда помнить.
 */
const value = prompt('Please enter a number!');
console.log(typeof value); // 'string'
console.log(value); // '5'`}
        language="javascript"
        showLineNumbers={false}
        theme={ocean}
      />
    </section>
  </section>
))
